import { render, staticRenderFns } from "./RemoveSubmitModal.vue?vue&type=template&id=517153e8&scoped=true&"
import script from "./RemoveSubmitModal.vue?vue&type=script&lang=js&"
export * from "./RemoveSubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveSubmitModal.vue?vue&type=style&index=0&id=517153e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517153e8",
  null
  
)

export default component.exports